(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 8191:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(393);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ dateFormat; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(120);

var dateFormat = function(input, format) {
    var date = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(input);
    var humanReadable = date.toFormat(format);
    return humanReadable;
};


/***/ }),

/***/ 393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4532);
/* harmony import */ var _app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1817);
/* harmony import */ var _app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7213);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5935);
/* harmony import */ var _app_helpers_DateTimeFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7135);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);








var Index = function(param) {
    var params = param.params;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), mode = ref[0], setMode = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // window.analytics.page("viewed");
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Privacy Policy | Storageunitauctionlist.com",
                description: "".concat(params.attributes.short_description)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container mx-auto ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-[2.625rem] lg:mt-[5.75rem] mx-4.5 md:mx-16 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "uppercase font-medium md:font-bold text-warning-500 text-regular-tight md:text-large-none",
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-neutral-900 font-bold text-title3 leading-[2.125rem] lg:!text-title1 mt-[1.375rem] md:mt-3.5 ",
                                children: params.attributes.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-3 md:mt-3.5 text-neutral-700 text-small-normal leading-6 md:!text-lg",
                                children: [
                                    "Last updated:",
                                    " ",
                                    (0,_app_helpers_DateTimeFormat__WEBPACK_IMPORTED_MODULE_6__/* .dateFormat */ .v)(params.attributes.updatedAt, "LLLL dd, yyyy")
                                ]
                            }),
                            params.attributes.cover.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full mt-3 md:mt-4.5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: "".concat("https://cms.storageunitauctionlist.com").concat(params.attributes.cover.data.attributes.url),
                                    alt: params.attributes.cover.data.attributes.alternativeText,
                                    className: "w-full rounded-3xl"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-6 ck-content",
                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(params.attributes.description)
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,935,659,774,888,179], function() { return __webpack_exec__(8191); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);